import { render } from "./AddHospital.vue?vue&type=template&id=cc060ae8&scoped=true"
import script from "./AddHospital.vue?vue&type=script&lang=js"
export * from "./AddHospital.vue?vue&type=script&lang=js"

import "./AddHospital.vue?vue&type=style&index=0&id=cc060ae8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc060ae8"]])

export default __exports__